<template>
  <div class="text-center">
    <div v-if="isMintActive && hasSupply">
      <div>
        <div class="mt-5 mb-4">
          <div>
            <label for="quantity">Quantity:</label
            ><input
              type="number"
              max="5"
              min="1"
              @change="handleQuantity"
              class="quantity"
              id="quantity"
              v-model="quantity"
            />
          </div>

          <div>
            <label>Price: {{ formatedPrice }} ETH</label>
          </div>
        </div>
      </div>
      <button class="claim-button" @click="mint">
        <template v-if="isConnected">MINT</template>
        <template v-else>CONNECT WALLET</template>
      </button>
      <div class="my-3">Supply: {{ totalSupply }}/{{ maxSupply }}</div>
    </div>
    <h2 class="my-5" v-else-if="isMintActive && !hasSupply">
      SOLD OUT
    </h2>
    <h2 class="my-5" v-else>
      Mint has not started yet!
    </h2>
    <v-loading-modal :active="loading || minting"></v-loading-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import dollsContractService from "../services/dollsContractService";
import VLoadingModal from "../components/LoadingModal.vue";
export default {
  components: {
    VLoadingModal,
  },
  data() {
    return {
      maxSupply: 0,
      totalSupply: 0,
      quantity: 1,
      isMintActive: false,
      loading: true,
      minting: false,
      interval: null,
      mintPrice: +process.env.VUE_APP_DOLLS_PRICE,
    };
  },
  computed: {
    ...mapState(["accountAddress", "networkId"]),
    ...mapGetters(["isConnected"]),
    hasSupply() {
      return this.maxSupply - this.totalSupply > 0;
    },
    formatedPrice() {
      return (this.mintPrice * this.quantity).toFixed(2);
    },
  },
  async mounted() {
    this.loadData();
    this.interval = setInterval(() => {
      this.loadData();
    }, 5000);
  },
  unmounted() {
    clearInterval(this.interval);
  },
  methods: {
    loadData() {
      Promise.all([
        dollsContractService.totalSupply(),
        dollsContractService.maxSupply(),
        dollsContractService.isMintActive(),
      ])
        .then(([totalSupply, maxSupply, isMintActive]) => {
          this.totalSupply = +totalSupply;
          this.maxSupply = +maxSupply;
          this.isMintActive = isMintActive;
        })
        .finally(() => (this.loading = false));
    },
    handleQuantity() {
      this.quantity =
        this.quantity > 6 ? 5 : this.quantity < 1 ? 1 : this.quantity;
    },
    async mint() {
      if (!this.isConnected) {
        try {
          await this.$wallet.connect();
        } catch (err) {
          return;
        }
      }

      if (this.networkId != process.env.VUE_APP_NETWORK_ID) {
        return;
      }

      this.minting = true;
      dollsContractService
        .mint(this.quantity, this.mintPrice, this.accountAddress)
        .then(() => this.$emit("minted"))
        .catch((err) => this.$showSnackbar(err.message, "danger"))
        .finally(() => (this.minting = false));
    },
  },
};
</script>

<style lang="css" scoped>
label {
  font-size: 22px;
  margin-right: 20px;
}
.quantity {
  width: 60px;
  text-align: center;
}
</style>
